import ActionPlanWidget from './action-plan-widget.vue';
import ButtonLinkWidget from './button-link-widget.vue';
import DetailedIndicatorWidget from './detailed-indicator-widget.vue';
import GwCompletedListWidget from './gw-completed-list-widget.vue';
import GwStatsWidget from './gw-stats-widget.vue';
import ImagesWidget from './images-widget.vue';
import IndicatorWidget from './indicator-widget.vue';
import InformationsWidget from './informations-widget.vue';
import PagesSlideshowWidget from './pages-slideshow-widget.vue';
import PendingWidget from './pending-widget.vue';
import ProblemsWidget from './problems-widget.vue';
import StatsWidget from './stats-widget.vue';
import StickersWidget from './stickers-widget.vue';
import TextPerDateWidget from './text-per-date-widget.vue';
import TextWidget from './text-widget.vue';
import ViewerWidget from './viewer-widget.vue';
import WheelWidget from './wheel-widget.vue';

export default {
  ActionPlanWidget,
  DetailedIndicatorWidget,
  GwCompletedListWidget,
  GwStatsWidget,
  ImagesWidget,
  IndicatorWidget,
  InformationsWidget,
  PagesSlideshowWidget,
  PendingWidget,
  ProblemsWidget,
  StatsWidget,
  StickersWidget,
  TextPerDateWidget,
  TextWidget,
  ViewerWidget,
  ButtonLinkWidget,
  WheelWidget,
};
